import { FC } from 'react'

import { OptionCheckbox } from '@syconium/little-miss-figgy'

import { trackEvent } from '../../../../../../lib/analytics'
import { getFilterKey } from '../../../../../../lib/reviews/utils'

export const MultipleSelectFilter: FC<{
  items: ReadonlyArray<{ name: string; localizedName?: string; value: string | string[] }>
  value: ReadonlyArray<string>
  onChange: (item: string) => void
}> = ({ items, value, onChange }) => {
  return (
    <div>
      {items.map(item => {
        const key = getFilterKey(item.value)

        return (
          <OptionCheckbox
            checked={value.includes(key)}
            key={key}
            name={item.name}
            onChange={() => onChange(key)}
            type='checkbox'
            value={key}
            {...trackEvent({
              category: 'reviews page',
              action: 'enable filter',
              label: item.name,
            })}
          >
            {item.localizedName ?? item.name}
          </OptionCheckbox>
        )
      })}
    </div>
  )
}
